export function formatParentTerritoryIds(ids: string[]): string {
  return ids
    .map(id => `topic_ids: ${id.split('.')[1]}`)
    .filter(Boolean)
    .join(' OR ')
}

/**
 * Builds the second clause of the copy query. A promoted niche card on the parent
 * Category page links to the Category it was promoted into, so it is scoped by that
 * Category's topic id (`topic_ids: {promoted}`) rather than the promoted niche's own
 * legacy query.
 */
export function formatTerritoryQueryClause({
  territoryQuery,
  isPromoted,
  promotedTargetId,
}: {
  territoryQuery: string
  isPromoted?: boolean | null
  promotedTargetId?: string | null
}): string {
  if (isPromoted && promotedTargetId) {
    return `topic_ids: ${promotedTargetId.split('.')[1] ?? promotedTargetId}`
  }

  const parsedQuery = JSON.parse(territoryQuery)
  return typeof parsedQuery.title === 'string' ? parsedQuery.title : ''
}
